import BackendApiClient from './BackendApiClient';
import { Response } from '../exports/Types';
import { Country } from 'react-phone-number-input';

export interface LocationInterface {
  country_code: Country;
  city: string;
}

class CurrentLocationManager {
  public get = async (): Promise<Response<LocationInterface>> =>
    BackendApiClient.request({
      method: 'GET',
      url: `/current-location`,
    });
}

export default new CurrentLocationManager();
